const select = {
  root: {
    borderRadius: 8,
  },
  icon: {
    top: 'calc(50% - 10px)',
    right: 0,
  },
  selectMenu: {
    paddingRight: '24px',
  },
};

export default select;
